import Dialog from '../../../../dialogs/dialog';
import { GlobalProvider } from '../../../../../utils/globalprovider';
import React from 'react';
import './commonmergeform.css';
import MergeSpeakerForm from '../mergespeakerform/mergespeakerform';

class CommonMergeSpeakerForm extends Dialog {
  constructor(props) {
    super(props);

    this.state.title = props.title;
    this.state.buttons = [
      {
        type: 'text',
        disabled: false,
        text: { fr: 'Valider', en: 'Submit' },
        key: 'submit',
      },
      { type: 'back', disabled: false },
    ];

    this.state.mergeSpeakerId = null;

    this.handleButton = this.handleButton.bind(this);
    this.onQuit = this.onQuit.bind(this);
    this.onSelectSpeaker = this.onSelectSpeaker.bind(this);

    this.mergeFormRef = React.createRef();
  }

  onQuit() {
    this.props.onButton({ name: 'back' });
  }

  onSelectSpeaker(mergeSpeakerId) {
     if (mergeSpeakerId !== -1) {
      this.setState({ mergeSpeakerId });
    }
  }

  handleButton(buttonkey) {
    switch (buttonkey) {
      case 'back':
        this.onQuit();
        break;

      case 'submit':
        if (!this.state.mergeSpeakerId) {
          this.onQuit();
          break;
        }

        this.props.onButton({
          name: 'submit',
          value: {
            speakerId: this.props.speaker.id,
            mergeSpeakerId: this.state.mergeSpeakerId,
          },
        });
        break;

      default:
        return;
    }
  }
  render() {
    const retour = (
      <div className="divmergeform">
        <GlobalProvider>
          <MergeSpeakerForm
            ref={this.mergeFormRef}
            speaker={this.props.speaker}
            speakers={this.props.speakers}
            onSelectSpeaker={this.onSelectSpeaker}
          ></MergeSpeakerForm>
        </GlobalProvider>
      </div>
    );

    return super.render(retour);
  }
}

export default CommonMergeSpeakerForm;
